import $ from 'jquery';
import Component from '../models/Component';

export default class ScrollOverlay extends Component {
 constructor(element, context) {
     super(element, context);

     $(() => {
         this.element.on('click', function(){
             window.scrollTo({
                 top: 500,
                 behavior: 'smooth'
             });
         });
     });
 }
}
